import { useCallback, useMemo } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { IsbnMultipleSelectChip } from "~/components/select/isbn-multiple-select-chip";

interface MultiTextInputProps {
  name: string;
}

export const MultiTextInput = ({ name }: MultiTextInputProps) => {
  const { setValue } = useFormContext();
  const value = useWatch({ name }) as string | undefined;
  const values = useMemo(
    () => value?.split(",").filter((v) => v) ?? [],
    [value],
  );

  const onSelectChange = useCallback(
    (v: string[]) => {
      setValue(name, v.filter(Boolean).join(","));
    },
    [setValue, name],
  );

  return (
    <div className="min-h-10 h-full flex-1 flex items-center relative border-secondary-300 border border-l-0 rounded-r-lg shadow-xs bg-white text-secondary-600">
      <Controller
        name={name}
        render={() => (
          <IsbnMultipleSelectChip
            values={values}
            onValueChange={onSelectChange}
            className="grid grid-cols-[repeat(auto-fill,175px)] auto-rows-[34px] gap-y-1 gap-x-2 py-0.5 px-1"
            chipClassName="text-sm"
          />
        )}
      />
    </div>
  );
};
